import { createTheme } from '@mui/material/styles'

export const shadows = (mode: 'dark' | 'light') => {
  const theme = createTheme()
  const transparent = mode === 'dark' ? '#02131d' : 'rgba(0, 0, 0, 0.16)'
  theme.shadows[0] = 'none'
  theme.shadows[1] = `${transparent} 0px 1px 4px`

  return theme.shadows
}
